module.exports = __webpack_public_path__ + "img/icon_location.a9425426.png";